import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-confirmation-popup',
    templateUrl: './confirmation-popup.component.html',
    styleUrls: ['./confirmation-popup.component.scss'],
    standalone: false
})
export class ConfirmationPopupComponent {
  @Input() title: string = 'Confirmation';
  @Input() message: string = '';
  @Input() buttonLabel: string = 'Confirm';
  @Input() isLoading: boolean = false;
  @Output() confirm = new EventEmitter<void>();
  
  faSpinner = faSpinner;

  constructor(public readonly activeModal: NgbActiveModal) {}

  onCancelClicked() {
    if (this.isLoading) return
    this.activeModal.dismiss();
  }

  onConfirmClicked() {
    this.confirm.emit();
  }
}
